<template>
  <!-- g-head -->
  <div class="g-hd">
    <div class="g-hd-l">
      <div class="txt" v-if="false">
        关联展会：
        <span v-if="exhibition && exhibition.name">
          <span>{{exhibition.name || '暂无'}}</span>
        </span>
        <span @click="linkToRouter('/exhibition/contact-exhibition')" class="bind" v-else>暂无展会</span>
        <!-- <img
          src="@/assets/img/guanlian.svg"
          class="contact"
          title="点击关联展会"
          @click="linkToRouter('/exhibition/contact-exhibition')"
        />-->
      </div>
      <exSteps v-if="showHome"></exSteps>
    </div>
    <div class="g-hd-r">
      <div class="back" @click="linkToRouter('/host/project')" v-if="showHome2" style="margin-right:20px;">
        <i class="icon iconfont icon-shouye11"></i>
        回首页
      </div>

      <!-- 公告 -->
      <!-- <Poptip placement="bottom" width="350">
        <div class="g-notice">
            <i class="icon iconfont icon-xiaoxi-copy" style="font-size:20px;"></i>
          <span style="margin-left:5px;">公告</span>
        </div>
        <div slot="content">
          <notice />
        </div>
      </Poptip> -->

      <div class="g-dropdown">
        <Dropdown trigger="click" placement="bottom-end">
          <div class="tool" style="display: flex;align-items: center;justify-content: flex-end;" :title="company.name" v-if="showHome">
            <i class="icon iconfont icon-yonghu"></i>
            <span v-if="company">{{company.name}}</span>
          </div>
          <div class="tool tool2" v-else>
            <i class="icon iconfont icon-yonghu"></i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem v-if="typeNum === 1">
              <div @click="$router.push('/exhibition/index/companyAccount')" class="g-dropdown-item">
                <i class="icon iconfont icon-peizhi1"></i>修改密码
              </div>
            </DropdownItem>
            <DropdownItem>
              <div @click="isExit=true;" class="g-dropdown-item">
                <i class="icon iconfont icon-tuichu"></i>退出
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>

    <iModal cancel-text title="" width="416" v-model="isExit" :closable="false" :footer-hide="true">
      <div class="exit-modal">
        <div class="exit-modal-top">
          <Icon type="ios-alert" color="#f90" size="28" />
          <p>确认</p>
        </div>
        <div class="exit-modal-bottom">
          <p>是否退出 ？</p>
        </div>
        <div class="exit-modal-btn">
          <Button type="text" @click="isExit=false;">取消</Button>
          <Button type="primary" @click="confirm()" style="margin-left:10px;">确定</Button>
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import notice from "@components/notice/notice.vue";
import exSteps from "@components/ex-steps/ex-steps.vue";
export default {
  props: {
    typeNum: { // 判断是否显示修改密码
      type: Number,
      default: function () {
        return 0;
      },
    },
  },
  data () {
    return {
      exhibition: null,
      isExit: false,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    path () {
      return this.$route.path;
    },
    showHome () {
      let bool = false;
      if (this.path && this.path.indexOf("/exhibition/index") !== -1) {
        bool = true;
      }
      if (this.path && this.path.indexOf("/exhibition/template") !== -1) {
        bool = true;
      }
      return bool;
    },
    showHome2 () {
      let bool = false;
      if (this.path && this.path.indexOf("/host/index") !== -1) {
        bool = true;
      }
      return bool;
    }
  },
  components: {
    notice,
    exSteps
  },
  async created () {
    if (this.showHome) {
      let join = await this.getDefaultJoinExhibition(this.company.id);
      if (join) {
        this.exhibition = await this.getExhibitionById(join.exhibitionId);
      }
    }
  },
  methods: {
    ...mapMutations({
      setExhibition: "loginModule/setExhibition"
    }),
    ...mapActions({
      exit: "loginModule/exit",
      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition",
      getExhibitionById: "exhibitionModule/getExhibitionById"
    }),
    linkToRouter (url) {
      if (this.path === url) return;
      this.$router.push(url);
    },
    confirm () {
      this.isExit = false;
      setTimeout(() => {
        this.exit();
      }, 100)
    }
  }
};
</script>

<style lang="scss">
.g-hd {
  // .ivu-poptip-popper {
  //   top: 54px !important;
  // }
  // .ivu-poptip-arrow,
  // .ivu-poptip-arrow:after {
  //   display: none;
  // }
  .ivu-poptip-body {
    padding: 0;
  }
  .ivu-badge-count {
    height: 12px;
    padding: 0 2px;
    border-radius: 5px;
    line-height: 10px;
    min-width: 12px;
    position: absolute;
    top: 10px;
  }
}
</style>
<style scoped lang='scss'>
.g-hd {
  height: 64px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #333;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  .contact {
    width: 18px;
    height: 18px;
    font-size: 21px;
    color: rgb(24, 144, 255);
    position: relative;
    top: 3px;
    left: 4px;
    cursor: pointer;
  }
  &-l {
    width: 70%;
    .txt {
      display: inline-block;
      .bind {
        &:hover {
          color: #1890ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
  &-r {
    width: 30%;
    font-size: 14px;
    color: #333;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .g-notice {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
  .tool {
    margin-left: 20px;
    cursor: pointer;
    .iconfont {
      font-size: 20px;
      color: #788592;
      font-weight: bold;
    }
    span {
      max-width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }
  }
  .back {
    min-width: 95px;
    height: 32px;
    background-color: rgba(#1890ff, 0.08);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .iconfont {
      font-size: 20px;
      font-weight: bold;
      display: inline-block;
      padding-right: 4px;
    }
  }
}
.g-dropdown {
  .ivu-dropdown-item {
    padding: 0;
  }
  &-item {
    padding: 7px 16px;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .g-hd {
    /deep/ .ivu-dropdown-rel {
      padding-top: 37px;
    }
  }
  .tool2 {
    margin-top: -37px;
  }
}
.exit-modal {
  padding: 6px 16px 8px;
  &-top {
    display: flex;
    align-items: center;
    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }
  &-bottom {
    margin-left: 40px;
  }
  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}
</style>